import styled, { keyframes } from 'styled-components'
import searchIcon from '@theme/icon/search.svg'
import { ColoredIcon } from 'component/ColoredIcon'
import Base64Image from 'component/Base64Image'
import closeIcon from '@theme/short-player-ui/icon-close.svg'

export const Wrapper = styled.div`
  user-select: none;
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  background-color: #000;
  color: white;
  min-height: 0;
`

export const SearchButton = styled.button`
  position: absolute;
  top: calc(env(safe-area-inset-top) + 1rem / 39 * 18);
  right: calc(1rem / 39 * 18);
  border-radius: 50%;
  border: 0;
  width: calc(1rem / 39 * 40);
  height: calc(1rem / 39 * 40);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconSearch = styled(ColoredIcon).attrs({
  src: searchIcon,
})`
  width: calc(1rem / 39 * 30);
  height: calc(1rem / 39 * 30);
`

export const FloatAdWrapper = styled.div`
  position: absolute;
  top: calc(env(safe-area-inset-top) + 1rem / 39 * 90);
  right: calc(1rem / 39 * 8);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FloatAdImage = styled(Base64Image).attrs({
  placeholder:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR4AWJiYGBgAAAAAP//XRcpzQAAAAZJREFUAwAADwADJDd96QAAAABJRU5ErkJggg==',
  source: 'picture',
})`
  width: calc(1rem / 39 * 70);
  height: calc(1rem / 39 * 70);
  border-radius: 50%;
  overflow: hidden;
`
const fadeInAnimation = keyframes`
 0% { opacity: 0 }
 100% { opacity: 1 }
`
export const FloatAdCloseButton = styled.button`
  margin-top: calc(1rem / 39 * 10);
  width: calc(1rem / 39 * 16);
  height: calc(1rem / 39 * 16);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeInAnimation} 0.5s ease-in-out;
`

export const FloatAdCloseIcon = styled(ColoredIcon).attrs({
  src: closeIcon,
})`
  width: calc(1rem / 29 * 16);
  height: calc(1rem / 29 * 16);
`
